<template>
  <div class="flex-col page">
    <div class="flex-row justify-center self-stretch relative group">
      <img
        @click="back"
        class="image pos"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=73da474f9f0a9d2a13c183e0f2ed8f88.png"
      />
      <span class="self-start text" @click="goSuccess">视频拍摄</span>
    </div>
    <img
      class="self-center image_2"
      src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=bb91ff48165d9daf73483bfb490dbbf6.png"
    />
    <span class="self-center text_2" @click="goFail">视频一键剪辑中</span>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      audit: true,
    };
  },
  created() {
    // setTimeout(() => {
    //   if (this.audit) {
    //     alert('视频中存在违规信息')
    //     this.$router.back()
    //   } else {
    //     this.$router.push({name: 'jianjiwancheng'})
    //   }
    // }, 3000)
  },
  methods: {
    goSuccess() {
      this.$router.push({name: 'jianjiwancheng'})
    },
    goFail() {
      alert('视频中存在违规信息')
      this.$router.back()
    },
    back() {
      this.$router.back()
    }
  },
};
</script>

<style scoped lang="less">
.page {
  padding: 14px 16px 402px;
  background-color: rgb(17, 17, 17);
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;

  .group {
    padding-bottom: 10px;

    .image {
      border-radius: 5px;
      width: 24px;
      height: 24px;
    }

    .pos {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    .text {
      color: rgb(255, 255, 255);
      font-size: 18px;
      font-family: 思源黑体;
      font-weight: 700;
      line-height: 17px;
    }
  }

  .image_2 {
    margin-top: 175px;
    width: 178px;
    height: 178px;
  }

  .text_2 {
    margin-top: 30px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 20px;
    font-family: 思源黑体;
    line-height: 18.5px;
  }
}
</style>
